export const iconFontAwesomeTimeHourglassEnd = (
	<i className="fa-solid fa-hourglass-end"></i>
);
